export default {
    exportEmployeeData: 'Export Employee Data',
    cancel: 'cancel',
    export: 'export',
    employeeInformation: 'Employee Information',
    tabletRegisterCode: 'Tablet Register Code',
    lineRegisterCode: 'Line Register Code'
}
